import React, { useContext } from 'react';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import EditAdButtom from './EditAdButton';
import {JsonAdSummary} from '../../ext/lib/types';
import {APIError, UnsafeAPIResponse} from '../../hooks/useApi';
import UserContext, {User} from '../common/UserContext';
import {handleResponse} from '../../ext/common/rest-api-helper';
import {jsonDateTimeFormat} from '../../ext/lib/temporal';
import {useState} from 'react';
import adSummaryList from './AdSummaryList';
import useApi from '../../hooks/useApi';
import * as R from 'ramda';

const AdActions: React.FC<{ad: JsonAdSummary }> = ({ad}) => {
  const {apiToken} = useContext(UserContext);
  const [isPaid, setIsPaid] = useState(Boolean(ad.paidAt));

  async function handlePaidChange(e: React.ChangeEvent<HTMLInputElement>): Promise<void> {
    const changeEventAdKey = (e: React.ChangeEvent<HTMLInputElement>): {adUser: string; adKey: string} => ({
      adUser: e.target.dataset.user as string,
      adKey: e.target.dataset.key as string
    });

    function setAdPaidState(adUser: string, adKey: string, isPaid: boolean): Promise<void> {
      return fetch(`/api/v1/requests/${btoa(adUser)}/${adKey}`, {
        method: 'PATCH',
        headers: {
          'Authorization': apiToken || 'missing-token',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(
          isPaid
           ? {paidAt: jsonDateTimeFormat(new Date())}
           : {paidAt: ''}
        )
      }).then(R.pipe(
        handleResponse as (_: Response) => Promise<void>,
        R.otherwise(err => {
          console.error('Unable to set ad paid state: %o', err);
          alert('Unable to set ad paid state. Try again or contact support');
        })
      ));
    }

    const {adUser, adKey} = changeEventAdKey(e);
    const checked = R.path(['target', 'checked'], e) as boolean;
    setIsPaid(checked);
    return setAdPaidState(adUser, adKey, checked);
  }

  return <>
    <FormControlLabel
      label="Paid"
      control={
        <Switch
          checked={isPaid}
          color="primary"
          inputProps={{
            // @ts-ignore TS definitions for Material UI Switch component have a problem with data attributes
            'data-user': ad.userEmailAddress,
            'data-key': ad.adKey
          }}
          onChange={handlePaidChange}
        />
      }
    />
    <EditAdButtom style={{marginLeft: '1em'}} adKey={ad.adKey} />
  </>;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const PayAdsList: React.FC<any> = adSummaryList(AdActions);

const PayAds: React.FC<{user: User; apiToken: string}> = ({user, apiToken}) => {
  const unsafeAds: UnsafeAPIResponse<JsonAdSummary[]> = useApi(apiToken, '/api/v1/requests/payment');
  if (R.pathEq(['@@type'], 'Error', unsafeAds)) {
    console.error((unsafeAds as APIError).message);
    return <div className="alert error">An error occurred while fetching ads. Try again or contact support</div>;
  } else {
    return <PayAdsList
      user={user}
      ads={unsafeAds as JsonAdSummary[]}
      emptyMessage="All ads have been paid."
    />;
  }
};
export default PayAds;
